import { useBreakpointValue } from "@gluestack-style/react";
import { zodResolver } from "@hookform/resolvers/zod";
import useToast from "@repo/core/components/core/Toast";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import useAuthStore from "@repo/core/stores/auth";
import { useForm } from "react-hook-form";
import { z } from "zod";

const formSchema = z.object({
  fullName: z.string().min(4),
  position: z.string()
});

export type FormDataType = z.infer<typeof formSchema>;

export const EditProfileController = () => {
  const { back } = useNavigation();
  const isTabletOrWeb = useBreakpointValue({ base: false, md: true });
  const { success } = useToast();
  const { user } = useAuthStore();

  const {
    control,
    formState: { isValid, isSubmitting },
    handleSubmit
  } = useForm<FormDataType>({
    resolver: zodResolver(formSchema),
    defaultValues: { fullName: user?.name, position: "Gerente" }
  });

  const handleOnSubmitForm = handleSubmit(() => {
    success("Dados alterados com sucesso!");
    back();
  });
  return {
    back,
    user,
    control,
    handleOnSubmitForm,
    isValid,
    isSubmitting,
    isTabletOrWeb
  };
};
